import { ApiCallState } from "../Utils";

export type RegularExpense = {
  id: number;
  user_id: number;

  starting_date: string;
  recurrence: string;
  description: string;
  amount: number;

  readonly createdAt: Date;
  readonly updatedAt: Date;
};

export type RegularExpenseStateTypes = {
  fetchAll: ApiCallState<RegularExpense[]>;
  fetchOne: ApiCallState<RegularExpense | {}>;
};

export const RegularExpenseActionTypes = {
  FETCH_ALL_REGULAR_EXPENSE: "FETCH_ALL_REGULAR_EXPENSE",
  FETCH_ALL_REGULAR_EXPENSE_RESET: "FETCH_ALL_REGULAR_EXPENSE_RESET",
  FETCH_ALL_REGULAR_EXPENSE_FAILURE: "FETCH_ALL_REGULAR_EXPENSE_FAILURE",
  FETCH_ALL_REGULAR_EXPENSE_SUCCESS: "FETCH_ALL_REGULAR_EXPENSE_SUCCESS",

  FETCH_ONE_REGULAR_EXPENSE: "FETCH_ONE_REGULAR_EXPENSE",
  FETCH_ONE_REGULAR_EXPENSE_RESET: "FETCH_ONE_REGULAR_EXPENSE_RESET",
  FETCH_ONE_REGULAR_EXPENSE_FAILURE: "FETCH_ONE_REGULAR_EXPENSE_FAILURE",
  FETCH_ONE_REGULAR_EXPENSE_SUCCESS: "FETCH_ONE_REGULAR_EXPENSE_SUCCESS",
};
